import { render, staticRenderFns } from "./BrButton.vue?vue&type=template&id=556a4234&"
import script from "./BrButton.vue?vue&type=script&lang=js&"
export * from "./BrButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports